
const CustomStyle = {
    multiselect: {
        '& .MuiInputBase-root': {
            fontSize: '13px',
            boxShadow: 'none',
            borderWidth: '1px',
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderWidth: '1px',
                borderColor: '#afc0f7',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#ced4da',
            },
            '.MuiOutlinedInput-notchedOutline': {
                borderColor: '#ced4da',
            },
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderWidth: '1px',
            borderColor: '#afc0f7',
        },
        '& .MuiFormHelperText-root': {
            fontSize: '12px',
        },
    },
    singleselect: {
        '& .MuiInputBase-root': {
            fontSize: '13px',
            boxShadow: 'none',
            borderWidth: '1px',
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderWidth: '1px',
                borderColor: '#afc0f7',
                
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#ced4da',
            },
            '.MuiOutlinedInput-notchedOutline': {
                borderColor: '#ced4da',
            },
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderWidth: '1px',
            borderColor: '#afc0f7',
        },
        '& .MuiFormHelperText-root': {
            fontSize: '12px',
        },
    },
};

export default CustomStyle;



// Common disabled input background color
export const DISABLED_INPUT_BG = '#e9ecef';

export const DETAILS_BG = "shadow-sm bg-light p-4 rounded-2 border border-secondary";




// Common function to get disabled input styles for MUI TextField/Autocomplete
export const getDisabledInputStyles = (disabled: boolean) => ({
    '& .MuiOutlinedInput-root': {
        backgroundColor: disabled ? DISABLED_INPUT_BG : '#fff',
        '&.Mui-disabled': {
            backgroundColor: DISABLED_INPUT_BG,
        },
        '& fieldset': {
            border: '1px solid #ced4da',
        },
        '&:hover fieldset': {
            border: '1px solid #ced4da',
        },
        '&.Mui-focused fieldset': {
            border: '1px solid #ced4da',
        },
    },
});

// Common Autocomplete dropdown styles
export const autocompleteDropdownStyles = {
    ListboxProps: {
        sx: {
            fontFamily: 'Poppins, sans-serif',
            fontSize: '13px',
            '& .css-1wpdqyc-MuiFormControl-root-MuiTextField-root': {
               borderRadius: '3px',
            },
            '& .MuiAutocomplete-option': {
                fontFamily: 'Poppins, sans-serif',
                fontSize: '13px',
            },
        },
    },
    renderOption: (props: any, option: any, getOptionLabel?: (option: any) => string) => {
        const { key, ...rest } = props;
        return (
            <li
                key={key}
                {...rest}
                style={{
                    fontFamily: 'Poppins, sans-serif',
                    fontSize: '13px',
                }}
            >
                {getOptionLabel ? getOptionLabel(option) : option?.toString() || ''}
            </li>
        );
    },
    // Common input field styles for selected value
    inputSx: {
        fontFamily: 'Poppins, sans-serif',
        '& input': {
            fontFamily: 'Poppins, sans-serif',
            fontSize: '13px',
        },
        '& .MuiInputBase-input::placeholder': {
            fontFamily: 'Poppins, sans-serif',
            fontSize: '13px',
        },
    },
};

// Common table styles with consistent color scheme
export const tableStyles = {
    // Primary color for table elements
    primaryColor: '#3969E7',
    
    // Secondary color for table elements
    secondaryColor: '#7e7357',
    
    // Table header styles
    header: {
        backgroundColor: '#3969E7',
        color: '#fff',
        fontFamily: 'Poppins, sans-serif',
        fontSize: '13px',
        fontWeight: 600,
        borderBottom: '2px solid #2a52cf',
        padding: '12px 8px',
        textAlign: 'center' as const,
    },
    
    // Alternative table header styles (for future use)
    headerAlt: {
        // backgroundColor: '#7e7357',
        // backgroundColor: '#054261ff',
        backgroundColor: '#2349b6',
        color: '#fff',
        fontFamily: 'Poppins, sans-serif',
        fontSize: '13px',
        fontWeight: 600,
        // borderBottom: '2px solid #6b6249',
        borderBottom: '2px solid #2349b6',
        padding: '12px 8px',
        textAlign: 'center' as const,
    },
    
    // Table cell styles
    cell: {
        fontFamily: 'Poppins, sans-serif',
        fontSize: '13px',
        padding: '8px',
        verticalAlign: 'middle' as const,
        borderBottom: '1px solid #e9ecef',
    },
    
    // Action column styles
    actionCell: {
        position: 'sticky' as const,
        right: 0,
        backgroundColor: '#fff',
        zIndex: 10,
        textAlign: 'center' as const,
        verticalAlign: 'middle' as const,
        padding: '8px',
        minWidth: '100px',
        width: '100px',
    },
    
    // Action column when editing
    actionCellEditing: {
        position: 'sticky' as const,
        right: 0,
        backgroundColor: '#f8f9fa',
        zIndex: 10,
        textAlign: 'center' as const,
        verticalAlign: 'middle' as const,
        padding: '8px',
        minWidth: '100px',
        width: '100px',
    },
    
    // Action column header styles
    actionHeader: {
        position: 'sticky' as const,
        right: 0,
        zIndex: 11,
    },
    
    // Action button container
    actionButtonContainer: {
        display: 'flex',
        gap: '6px',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
    },
    
    // Table row hover effect
    rowHover: {
        transition: 'background-color 0.2s ease',
        '&:hover': {
            backgroundColor: '#f8f9fa',
        },
    },
    
    // Editing row background
    rowEditing: {
        backgroundColor: '#f8f9fa',
        transition: 'background-color 0.2s ease',
    },
};

// Common FilterPopover styles
export const filterPopoverStyles = {
    // Primary color for filter popover
    primaryColor: '#3969E7',
    
    // Common font styles
    fontFamily: 'Poppins, sans-serif',
    fontSize: '13px',
    
    // Popover container styles
    container: {
        fontFamily: 'Poppins, sans-serif',
    },
    
    // TextField styles for search input
    textField: {
        fontFamily: 'Poppins, sans-serif',
        '& input': {
            fontFamily: 'Poppins, sans-serif',
            fontSize: '13px',
        },
        '& .MuiInputLabel-root': {
            fontFamily: 'Poppins, sans-serif',
            fontSize: '13px',
            '&.Mui-focused': {
                color: '#3969E7 !important',
            },
        },
        '& .MuiFormHelperText-root': {
            fontFamily: 'Poppins, sans-serif',
            fontSize: '13px',
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#3969E7',
            },
        },
        // Date picker calendar styles
        '& input[type="date"]::-webkit-calendar-picker-indicator': {
            cursor: 'pointer',
        },
        '& input[type="date"]': {
            colorScheme: 'light',
        },
    },
    
    // Autocomplete TextField styles
    autocompleteTextField: {
        fontFamily: 'Poppins, sans-serif',
        '& input': {
            fontFamily: 'Poppins, sans-serif',
            fontSize: '13px',
        },
        '& .MuiInputLabel-root': {
            fontFamily: 'Poppins, sans-serif',
            fontSize: '13px',
            '&.Mui-focused': {
                color: '#3969E7 !important',
            },
        },
        '& .MuiFormHelperText-root': {
            fontFamily: 'Poppins, sans-serif',
            fontSize: '13px',
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#3969E7',
            },
        },
    },
    
    // Button styles
    button: {
        fontFamily: 'Poppins, sans-serif',
        fontSize: '13px',
    },
    
    // Cancel button styles
    cancelButton: {
        fontFamily: 'Poppins, sans-serif',
        fontSize: '13px',
        borderColor: '#ced4da',
        color: '#212529',
        '&:hover': {
            borderColor: '#adb5bd',
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
        '&.Mui-focused': {
            borderColor: '#ced4da !important',
            boxShadow: '0 0 0 0.2rem rgba(206, 212, 218, 0.5) !important',
        },
        '&:focus-visible': {
            outline: 'none',
            borderColor: '#ced4da !important',
            boxShadow: '0 0 0 0.2rem rgba(206, 212, 218, 0.5) !important',
        },
    },
    
    // Apply button styles (primary color)
    applyButton: {
        fontFamily: 'Poppins, sans-serif',
        fontSize: '13px',
        backgroundColor: '#3969E7',
        '&:hover': {
            backgroundColor: '#2a52cf',
        },
    },
    
    // React DatePicker styles
    datePicker: {
        width: '100%',
        fontFamily: 'Poppins, sans-serif',
        fontSize: '13px',
    },
};

// MUI DatePicker calendar styles with primary color
export const muiDatePickerStyles = {
    // Calendar picker styles
    calendar: {
        '& .MuiPickersCalendarHeader-root': {
            backgroundColor: '#3969E7',
            color: '#fff',
        },
        '& .MuiPickersCalendarHeader-label': {
            color: '#fff',
            fontFamily: 'Poppins, sans-serif',
            fontSize: '13px',
        },
        '& .MuiPickersArrowSwitcher-button': {
            color: '#fff',
        },
        '& .MuiDayCalendar-weekContainer': {
            '& .MuiPickersDay-root': {
                fontFamily: 'Poppins, sans-serif',
                fontSize: '13px',
                '&.Mui-selected': {
                    backgroundColor: '#3969E7',
                    color: '#fff',
                    '&:hover': {
                        backgroundColor: '#2a52cf',
                    },
                },
                '&:hover': {
                    backgroundColor: 'rgba(57, 105, 231, 0.1)',
                },
            },
        },
    },
};

// React DatePicker CSS styles for primary color
export const datePickerStyles = `
  .react-datepicker {
    font-family: 'Poppins, sans-serif' !important;
    font-size: 13px !important;
  }
  
  .react-datepicker__header {
    background-color: #3969E7 !important;
    border-bottom: none !important;
  }
  
  .react-datepicker__current-month,
  .react-datepicker__day-name {
    color: #fff !important;
    font-family: 'Poppins, sans-serif' !important;
    font-size: 13px !important;
  }
  
  .react-datepicker__day--selected,
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range {
    background-color: #3969E7 !important;
    color: #fff !important;
  }
  
  .react-datepicker__day--selected:hover,
  .react-datepicker__day--in-selecting-range:hover,
  .react-datepicker__day--in-range:hover {
    background-color: #2a52cf !important;
  }
  
  .react-datepicker__day:hover {
    background-color: rgba(57, 105, 231, 0.1) !important;
  }
  
  .react-datepicker__day--keyboard-selected {
    background-color: rgba(57, 105, 231, 0.2) !important;
    color: #212529 !important;
  }
  
  .react-datepicker__day--keyboard-selected:hover {
    background-color: #3969E7 !important;
    color: #fff !important;
  }
  
  .react-datepicker__triangle {
    border-bottom-color: #3969E7 !important;
  }
  
  .react-datepicker__input-container input {
    font-family: 'Poppins, sans-serif' !important;
    font-size: 13px !important;
    width: 100% !important;
    padding: 8px 12px !important;
    border: 1px solid #ced4da !important;
    border-radius: 4px !important;
  }
  
  .react-datepicker__input-container input:focus {
    outline: none !important;
    border-color: #3969E7 !important;
    box-shadow: 0 0 0 0.2rem rgba(57, 105, 231, 0.25) !important;
  }
  
  /* Ensure datepicker calendar appears above MUI Popover */
  .react-datepicker-popper {
    z-index: 1400 !important;
  }
  
  .react-datepicker {
    z-index: 1400 !important;
  }
`;

